import React from "react";
import PropTypes from "prop-types";
import FormField from "./FormField";
import { Checkbox } from "@mui/material";

function FormCheckbox(props) {
  return (
    <FormField
      defaultValue={false}
      {...props}
      Field={Checkbox}
      fieldProps={(props) => ({ checked: props.value ?? false, style: null, value: undefined })}
    />
  );
}

FormCheckbox.propTypes = {
  name: PropTypes.string.isRequired, // FormField props
  tKey: PropTypes.string, // FormField props
  tDefault: PropTypes.string, // FormField props
  permissionKey: PropTypes.string, // FormField props
  gridSizes: PropTypes.object, // FormField props
  label: PropTypes.oneOf([PropTypes.element, PropTypes.string]), // FormField props
};

export default FormCheckbox;
